import React from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  Step,
  StepTitle,
  StepGraphics,
} from "./styles/form-step-styles";

const FormStep = ({ step }) => (
  <Wrapper>
    <Step>
      <StepTitle active={step === 1}>1. Job details</StepTitle>
      <StepGraphics active={step === 1} />
    </Step>
    <Step>
      <StepTitle active={step === 2}>2. Description</StepTitle>
      <StepGraphics active={step === 2} />
    </Step>
    <Step>
      <StepTitle active={step === 3}>3. Benefits</StepTitle>
      <StepGraphics active={step === 3} />
    </Step>
  </Wrapper>
);

FormStep.propTypes = {
  step: PropTypes.number.isRequired,
};

export default FormStep;
